export default __webpack_public_path__ + "static/media/plus.ad25b0de.gif";